import {WS_ASSISTANT_METADATA} from 'ws'

export interface ChatMessage {
  id: string
  chatId: string // assignmentId
  senderUserId: string
  recipientUserId: string
  message: string
  date: number
  sent?: boolean
  metadata?: WS_ASSISTANT_METADATA
}

export class ChatMessageSet {
  private set = new Set<ChatMessage>()

  get() {
    return this.set
  }

  add(value: ChatMessage) {
    let exists = false
    this.set.forEach((message) => {
      if (message.id === value.id) {
        exists = true
      }
    })
    if (!exists) {
      this.set.add(value)
    }
  }
}
